import {
  getTransform,
  getTransformPure,
  getTransformExt,
  calculateTransform,
} from "../transform/index";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
/**
 * Converts a point in the page coordinate system to the pixel coordinate
 * system
 *
 * @param {HTMLElement} element The  element within which the input point lies
 * @param {Number} pageX The x value in the page coordinate system
 * @param {Number} pageY The y value in the page coordinate system
 *
 * @returns {{x: Number, y: Number}} The transformed point in the pixel coordinate system
 */
function pageToPixel(element, pageX, pageY) {
  const enabledElement = getEnabledElement(element);
  //const enabledElement = elementStub;

  // if (enabledElement.image === undefined) {
  //   throw new Error('image has not been loaded yet');
  // }

  // Convert the pageX and pageY to the canvas client coordinates
  //const rect = element.getBoundingClientRect();
  let pt = {};
  let transform = null;
  try {
    const rect = enabledElement.canvas.getBoundingClientRect();
    const clientX = pageX - rect.left - window.pageXOffset;
    const clientY = pageY - rect.top - window.pageYOffset;

    pt = { x: clientX, y: clientY };
    transform = getTransform(enabledElement);

    transform.invert();
  } catch (e) {
    //console.log("error ");
  }
  return transform.transformPoint(pt.x, pt.y);
}

function canvasToPixel(element, pt) {
  const enabledElement = getEnabledElement(element);
  const transform = getTransform(enabledElement);

  transform.invert();

  return transform.transformPoint(pt.x, pt.y);
}

/**
 * Converts a point in the pixel coordinate system to the canvas coordinate system
 * system.  This can be used to render using canvas context without having the weird
 * side effects that come from scaling and non square pixels
 *
 * @param {HTMLElement} element An HTML Element enabled for
 * @param {{x: Number, y: Number}} pt The transformed point in the pixel coordinate system
 *
 * @returns {{x: Number, y: Number}} The input point in the canvas coordinate system
 * @memberof PixelCoordinateSystem
 */
function pixelToCanvas(element, pt) {
  const enabledElement = getEnabledElement(element);
  const transform = getTransform(enabledElement);

  return transform.transformPoint(pt.x, pt.y);
}

function pixelToCanvasExt(element, pt, ignoreTranslation = false) {
  const enabledElement = getEnabledElement(element);
  const transform = getTransformExt(enabledElement, ignoreTranslation);

  return transform.transformPoint(pt.x, pt.y);
}

function pixelToCanvasPure(canvas, viewport, pixelSpacing, pt) {
  const transform = getTransformPure(canvas, viewport, pixelSpacing);

  return transform.transformPoint(pt.x, pt.y);
}

/**
 * Sets the canvas context transformation matrix to the pixel coordinate system.  This allows
 * geometry to be driven using the canvas context using coordinates in the pixel coordinate system
 * @param {EnabledElement} enabledElement The
 * @param {CanvasRenderingContext2D} context The CanvasRenderingContext2D for the enabledElement's Canvas
 * @param {Number} [scale] Optional scale to apply
 * @returns {void}
 */
function setToPixelCoordinateSystem(enabledElement, context, scale) {
  if (enabledElement === undefined) {
    throw new Error(
      "setToPixelCoordinateSystem: parameter enabledElement must not be undefined"
    );
  }
  if (context === undefined) {
    throw new Error(
      "setToPixelCoordinateSystem: parameter context must not be undefined"
    );
  }

  const transform = calculateTransform(enabledElement, scale);

  context.setTransform(
    transform.m[0],
    transform.m[1],
    transform.m[2],
    transform.m[3],
    transform.m[4],
    transform.m[5]
  );
}

export {
  pageToPixel,
  canvasToPixel,
  pixelToCanvas,
  pixelToCanvasExt,
  pixelToCanvasPure,
  setToPixelCoordinateSystem,
};
